import React from 'react'
import { defineMessages } from 'react-intl'

import FAQItem from 'components/FaqItem'
import PageSubTitle from 'components/Page/Page.SubTitle.js'
import { View } from 'components/View.js'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'

// Focused messages for the /track-calories landing page
const faqMessages = defineMessages({
  sectionTitle: {
    id: 'TrackCaloriesFAQItems.sectionTitle',
    defaultMessage: 'Calorie Tracking & Free Trial'
  },

  // Q1: How it works (photo/voice/type)
  howItWorksQ: {
    id: 'TrackCaloriesFAQItems.howItWorksQ',
    defaultMessage: 'How do I track calories in seconds?'
  },
  howItWorksA: {
    id: 'TrackCaloriesFAQItems.howItWorksA',
    defaultMessage:
      'Use a photo, your voice, or typing. Our AI estimates calories and macros instantly so you can log a meal in seconds.'
  },

  // Q2: Accuracy
  accuracyQ: {
    id: 'TrackCaloriesFAQItems.accuracyQ',
    defaultMessage: 'How accurate is the AI estimate?'
  },
  accuracyA: {
    id: 'TrackCaloriesFAQItems.accuracyA',
    defaultMessage:
      'Results are a smart estimate based on your input and photo. Best results come from clear photos and common meals. You can always edit calories, protein, carbs, and fat.'
  },

  // Q3: Manual edits
  editQ: {
    id: 'TrackCaloriesFAQItems.editQ',
    defaultMessage: 'Can I edit the macros manually?'
  },
  editA: {
    id: 'TrackCaloriesFAQItems.editA',
    defaultMessage:
      'Yes. You can adjust calories and each macro anytime. The goal is speed first, control when you want it.'
  },

  // Q4: Platforms
  platformsQ: {
    id: 'TrackCaloriesFAQItems.platformsQ',
    defaultMessage: 'Does it work on iOS and Android?'
  },
  platformsA: {
    id: 'TrackCaloriesFAQItems.platformsA',
    defaultMessage:
      'Yes. Gymaholic is available on both the App Store and Google Play.'
  },

  // Q5: Trial clarity
  trialQ: {
    id: 'TrackCaloriesFAQItems.trialQ',
    defaultMessage: 'Is there a free trial? Will I be charged today?'
  },
  trialA: {
    id: 'TrackCaloriesFAQItems.trialA',
    defaultMessage:
      'You can start a 7-day free trial with $0 due today. Cancel anytime during the trial to avoid charges.'
  },

  // Q6: Workouts expectation
  workoutsQ: {
    id: 'TrackCaloriesFAQItems.workoutsQ',
    defaultMessage: 'I came for calorie tracking. Why do I see workouts in the app?'
  },
  workoutsA: {
    id: 'TrackCaloriesFAQItems.workoutsA',
    defaultMessage:
      'Calorie tracking is the star of Gymaholic, and workouts are included to help you stay consistent. Use as much or as little of the workout features as you like.'
  }
})

const FAQ_ITEMS = [
  {
    title: faqMessages.sectionTitle,
    items: [
      {
        question: faqMessages.howItWorksQ,
        answer: faqMessages.howItWorksA
      },
      {
        question: faqMessages.accuracyQ,
        answer: faqMessages.accuracyA
      },
      {
        question: faqMessages.editQ,
        answer: faqMessages.editA
      },
      {
        question: faqMessages.platformsQ,
        answer: faqMessages.platformsA
      },
      {
        question: faqMessages.trialQ,
        answer: faqMessages.trialA
      },
      {
        question: faqMessages.workoutsQ,
        answer: faqMessages.workoutsA
      }
    ]
  }
]

export function TrackCaloriesFAQItems () {
  const intl = useIntl()

  return (
    <View className='app-faq-items'>
      {
        FAQ_ITEMS.map((section) => {
          const titleStr = formatMessageIntlUtil(intl, section.title)

          return (
            <View key={titleStr}>
              <PageSubTitle>{titleStr}</PageSubTitle>

              {
                section.items.map((item) => {
                  const questionStr = formatMessageIntlUtil(intl, item.question)
                  const answerStr = formatMessageIntlUtil(intl, item.answer)

                  return (
                    <FAQItem
                      key={questionStr}
                      question={questionStr}
                      answer={
                        <View style={{
                          textAlign: 'left'
                        }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: markdownToHtmlStringUtil(answerStr)
                            }}
                          />
                        </View>
                      }
                    />
                  )
                })
              }
            </View>
          )
        })
      }
    </View>
  )
}
